import { render, staticRenderFns } from "./FormDateAndLocations.vue?vue&type=template&id=0d60a802&scoped=true&"
import script from "./FormDateAndLocations.vue?vue&type=script&lang=js&"
export * from "./FormDateAndLocations.vue?vue&type=script&lang=js&"
import style0 from "./FormDateAndLocations.vue?vue&type=style&index=0&id=0d60a802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60a802",
  null
  
)

/* custom blocks */
import block0 from "./FormDateAndLocations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d60a802')) {
      api.createRecord('0d60a802', component.options)
    } else {
      api.reload('0d60a802', component.options)
    }
    module.hot.accept("./FormDateAndLocations.vue?vue&type=template&id=0d60a802&scoped=true&", function () {
      api.rerender('0d60a802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/FormDateAndLocations.vue"
export default component.exports